import { IconButtonProps } from "@mui/material";
import React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { AppPrintIcon } from "../../Icon/AppPrintIcon";
import { AppToolButton } from "ui/Scripts/source/components/framework/Button/AppToolButton";

interface IPrintToolButtonProps extends IconButtonProps {
    tooltip?: string
}

export const PrintToolButton = (props: IPrintToolButtonProps) => (
    <AppToolButton
        {...props}
        tooltip={props.tooltip ?? Translations.Print}
        icon={<AppPrintIcon />}
    />
);
